import type { Lang, TKey } from "../../i18n/translations";
import type { StatKey, StatsConfig } from "../types";

const KEY_TO_TKEY: Record<StatKey, TKey> = {
  cities: "statCities",
  locations: "statLocations",
  ac: "statAcSockets",
  dc: "statDcSockets",
};

export function labelFor(
  key: StatKey,
  cfg: StatsConfig,
  t: (k: TKey) => string,
  _lang: Lang
): string {
  return cfg.labels[key] ?? t(KEY_TO_TKEY[key]);
}
